






























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwFloorAreaAttic from "./FloorAreaAttic.vue";
import iwAccessibleWithFixedStairs from "./AccessibleWithFixedStairs.vue";
import iwIsIsolatedAttic from "./IsIsolatedAttic.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwFloorAreaAttic: iwFloorAreaAttic,
        iwAccessibleWithFixedStairs: iwAccessibleWithFixedStairs,
        iwIsIsolatedAttic: iwIsIsolatedAttic,
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },
    data: function() {
        return {
            pathInStoreExists: "property.attic.exists",
            pathInStoreFloorAreaAttic: "property.attic.surface",
            checkboxes: [
                {
                    value: "hasAttic",
                    label: "is_there_an_attic"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasAttic"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreFloorAreaAttic);
        },
        isOpen: function(): boolean {
            let isOpen = false;

            if(this.valueChecked && this.valueChecked.length > 0) {
                isOpen = true;
            }
            return isOpen;
        },
        floorAreaAtticInput: function(): Vue | void {
            const accordionComponent = this.$refs.floorAreaAttic as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.floorAreaAtticInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        },
        accessibleWithFixedStairsInput: function(): Vue | void {
            const accordionComponent = this.$refs.accessibleWithFixedStairs as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.accessibleWithFixedStairsInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        },
        isIsolatedAtticInput: function(): Vue | void {
            const accordionComponent = this.$refs.isIsolatedAttic as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.isIsolatedAtticInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
    },
    methods: {
        updateValueFloorAreaAttic: function(floorAreaAttic: number): void {
            if (floorAreaAttic == 0 && this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaAttic) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaAttic);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreFloorAreaAttic, "value": floorAreaAttic});
            }
        },
        updateValue: function(selectedValues:  Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.floorAreaAtticInput) {
                    this.floorAreaAtticInput.$data.internalInput = 1;
                }
                if(this.accessibleWithFixedStairsInput) {
                    this.accessibleWithFixedStairsInput.$data.selectedValues = [];
                    this.$store.commit("FormModule/deleteValue", "property.attic.isAccessibleWithFixedStairs");
                }
                if(this.isIsolatedAtticInput) {
                    this.isIsolatedAtticInput.$data.selectedValues = [];
                    this.$store.commit("FormModule/deleteValue", "property.attic.isIsolated");
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaAttic);
            }
        }
    },
});
